import { createBiomassGame } from '@/game/BiomassGame';

createBiomassGame();
